export const surveyUrl =
  'https://forms.office.com/pages/responsepage.aspx?id=bnb6gUmjZ0iL9Ks14lCgj1Pdu3ATApxAiU5p6-z78RRURjJOQUZIMjQwS1oxNU1LTU4wSVgxUFA4OS4u';
